import axios from 'axios'
import { toastErrorLog } from '../../helpers/toastErrorLog'

// Token getter function - this will be set by the LoginContext
let getToken = () => localStorage.getItem('jwt')

// Function to update the token getter (called by LoginContext)
export const setTokenGetter = (tokenGetter) => {
  getToken = tokenGetter
}

axios.interceptors.request.use(
  (config) => {
    const token = getToken()
    if (token) {
      config.headers.authorization = `Bearer ${token}`
    }
    if (
      !config.headers['Content-Type'] &&
      !config.headers['content-type'] &&
      !(config.data instanceof FormData)
    ) {
      config.headers['Content-Type'] = 'application/json'
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.config?.meta?.toastMessage) {
      const tipoError = error.config.meta.tipoError || 'general'
      toastErrorLog(error, error.config.meta.toastMessage, tipoError)
    }

    return Promise.reject(error)
  }
)

export default {
  get: axios.get,
  request: axios.request,
  post: axios.post,
  put: axios.put,
  patch: axios.patch,
  delete: axios.delete
}
